/**
 * Generated from ch4_p01.fla
 */
export function ch4_p01(this: Ich4_p01) {
	const buttons = this.buttons;
	if (!buttons[0] && buttons.elementFactory) {
		buttons[0] = buttons.elementFactory(0,undefined);
	}
	if (buttons[0]) {
		ch4_p01_hh_ch4_p01psdAssetegmusbtnvar1.call(buttons[0] as Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar1);
		buttons[0].x = 935.25;
		buttons[0].y = 643;
		buttons[0].width = 140.50;
		buttons[0].height = 140.00;
		buttons[0].alpha = 1;
		if (buttons[0].onLayout) buttons[0].onLayout();
	}
	if (!buttons[1] && buttons.elementFactory) {
		buttons[1] = buttons.elementFactory(1,undefined);
	}
	if (buttons[1]) {
		ch4_p01_hh_ch4_p01psdAssetegmusbtnvar2.call(buttons[1] as Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar2);
		buttons[1].x = 1083.5;
		buttons[1].y = 644;
		buttons[1].width = 141.00;
		buttons[1].height = 139.00;
		buttons[1].alpha = 1;
		if (buttons[1].onLayout) buttons[1].onLayout();
	}
	if (!buttons[2] && buttons.elementFactory) {
		buttons[2] = buttons.elementFactory(2,undefined);
	}
	if (buttons[2]) {
		ch4_p01_hh_ch4_p01psdAssetegmusbtnvar3.call(buttons[2] as Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar3);
		buttons[2].x = 1234.5;
		buttons[2].y = 643.75;
		buttons[2].width = 140.00;
		buttons[2].height = 141.50;
		buttons[2].alpha = 1;
		if (buttons[2].onLayout) buttons[2].onLayout();
	}
	const sections = this.sections;
	if (!sections[0] && sections.elementFactory) {
		sections[0] = sections.elementFactory(0,undefined);
	}
	if (sections[0]) {
		ch4_p01_hh_ch4_p01psdAssetSection1.call(sections[0] as Ich4_p01_hh_ch4_p01psdAssetSection1);
		sections[0].x = 362.5;
		sections[0].y = 152;
		sections[0].width = 725.00;
		sections[0].height = 141.00;
		sections[0].alpha = 1;
		if (sections[0].onLayout) sections[0].onLayout();
	}
	if (!sections[1] && sections.elementFactory) {
		sections[1] = sections.elementFactory(1,undefined);
	}
	if (sections[1]) {
		ch4_p01_hh_ch4_p01psdAssetSection2.call(sections[1] as Ich4_p01_hh_ch4_p01psdAssetSection2);
		sections[1].x = 858;
		sections[1].y = 152.75;
		sections[1].width = 457.00;
		sections[1].height = 139.50;
		sections[1].alpha = 1;
		if (sections[1].onLayout) sections[1].onLayout();
	}
	if (!sections[2] && sections.elementFactory) {
		sections[2] = sections.elementFactory(2,undefined);
	}
	if (sections[2]) {
		ch4_p01_hh_ch4_p01psdAssetSection3.call(sections[2] as Ich4_p01_hh_ch4_p01psdAssetSection3);
		sections[2].x = 1312.75;
		sections[2].y = 152;
		sections[2].width = 702.50;
		sections[2].height = 141.00;
		sections[2].alpha = 1;
		if (sections[2].onLayout) sections[2].onLayout();
	}
	const bg = this.bg;
	ch4_p01_hh_ch4_p01psdAssetLayer0.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hh_ch4_p01psdAssetSec1Notes1Yellow = this.hh_ch4_p01psdAssetSec1Notes1Yellow;
	ch4_p01_hh_ch4_p01psdAssetSec1Notes1Yellow.call(this.hh_ch4_p01psdAssetSec1Notes1Yellow);
	hh_ch4_p01psdAssetSec1Notes1Yellow.x = 373.25;
	hh_ch4_p01psdAssetSec1Notes1Yellow.y = 119.5;
	hh_ch4_p01psdAssetSec1Notes1Yellow.width = 78.50;
	hh_ch4_p01psdAssetSec1Notes1Yellow.height = 147.00;
	hh_ch4_p01psdAssetSec1Notes1Yellow.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec1Notes1Yellow.onLayout) hh_ch4_p01psdAssetSec1Notes1Yellow.onLayout();
	const hh_ch4_p01psdAssetSec1Notes2 = this.hh_ch4_p01psdAssetSec1Notes2;
	ch4_p01_hh_ch4_p01psdAssetSec1Notes2.call(this.hh_ch4_p01psdAssetSec1Notes2);
	hh_ch4_p01psdAssetSec1Notes2.x = 613.25;
	hh_ch4_p01psdAssetSec1Notes2.y = 164.25;
	hh_ch4_p01psdAssetSec1Notes2.width = 34.50;
	hh_ch4_p01psdAssetSec1Notes2.height = 106.50;
	hh_ch4_p01psdAssetSec1Notes2.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec1Notes2.onLayout) hh_ch4_p01psdAssetSec1Notes2.onLayout();
	const hh_ch4_p01psdAssetSec1Notes3 = this.hh_ch4_p01psdAssetSec1Notes3;
	ch4_p01_hh_ch4_p01psdAssetSec1Notes3.call(this.hh_ch4_p01psdAssetSec1Notes3);
	hh_ch4_p01psdAssetSec1Notes3.x = 425;
	hh_ch4_p01psdAssetSec1Notes3.y = 214;
	hh_ch4_p01psdAssetSec1Notes3.width = 35.00;
	hh_ch4_p01psdAssetSec1Notes3.height = 117.00;
	hh_ch4_p01psdAssetSec1Notes3.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec1Notes3.onLayout) hh_ch4_p01psdAssetSec1Notes3.onLayout();
	const hh_ch4_p01psdAssetSec1Notes5Red = this.hh_ch4_p01psdAssetSec1Notes5Red;
	ch4_p01_hh_ch4_p01psdAssetSec1Notes5Red.call(this.hh_ch4_p01psdAssetSec1Notes5Red);
	hh_ch4_p01psdAssetSec1Notes5Red.x = 514.75;
	hh_ch4_p01psdAssetSec1Notes5Red.y = 131.25;
	hh_ch4_p01psdAssetSec1Notes5Red.width = 109.50;
	hh_ch4_p01psdAssetSec1Notes5Red.height = 123.50;
	hh_ch4_p01psdAssetSec1Notes5Red.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec1Notes5Red.onLayout) hh_ch4_p01psdAssetSec1Notes5Red.onLayout();
	const hh_ch4_p01psdAssetSec2Notes5blue = this.hh_ch4_p01psdAssetSec2Notes5blue;
	ch4_p01_hh_ch4_p01psdAssetSec2Notes5blue.call(this.hh_ch4_p01psdAssetSec2Notes5blue);
	hh_ch4_p01psdAssetSec2Notes5blue.x = 704.75;
	hh_ch4_p01psdAssetSec2Notes5blue.y = 98.75;
	hh_ch4_p01psdAssetSec2Notes5blue.width = 109.50;
	hh_ch4_p01psdAssetSec2Notes5blue.height = 123.50;
	hh_ch4_p01psdAssetSec2Notes5blue.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec2Notes5blue.onLayout) hh_ch4_p01psdAssetSec2Notes5blue.onLayout();
	const hh_ch4_p01psdAssetSec2Notes4Yellow = this.hh_ch4_p01psdAssetSec2Notes4Yellow;
	ch4_p01_hh_ch4_p01psdAssetSec2Notes4Yellow.call(this.hh_ch4_p01psdAssetSec2Notes4Yellow);
	hh_ch4_p01psdAssetSec2Notes4Yellow.x = 879.75;
	hh_ch4_p01psdAssetSec2Notes4Yellow.y = 149.75;
	hh_ch4_p01psdAssetSec2Notes4Yellow.width = 239.50;
	hh_ch4_p01psdAssetSec2Notes4Yellow.height = 128.50;
	hh_ch4_p01psdAssetSec2Notes4Yellow.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec2Notes4Yellow.onLayout) hh_ch4_p01psdAssetSec2Notes4Yellow.onLayout();
	const hh_ch4_p01psdAssetSec3Notes2Red = this.hh_ch4_p01psdAssetSec3Notes2Red;
	ch4_p01_hh_ch4_p01psdAssetSec3Notes2Red.call(this.hh_ch4_p01psdAssetSec3Notes2Red);
	hh_ch4_p01psdAssetSec3Notes2Red.x = 1047.25;
	hh_ch4_p01psdAssetSec3Notes2Red.y = 102.25;
	hh_ch4_p01psdAssetSec3Notes2Red.width = 34.50;
	hh_ch4_p01psdAssetSec3Notes2Red.height = 106.50;
	hh_ch4_p01psdAssetSec3Notes2Red.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec3Notes2Red.onLayout) hh_ch4_p01psdAssetSec3Notes2Red.onLayout();
	const hh_ch4_p01psdAssetSec3Notes1Blue = this.hh_ch4_p01psdAssetSec3Notes1Blue;
	ch4_p01_hh_ch4_p01psdAssetSec3Notes1Blue.call(this.hh_ch4_p01psdAssetSec3Notes1Blue);
	hh_ch4_p01psdAssetSec3Notes1Blue.x = 1192.25;
	hh_ch4_p01psdAssetSec3Notes1Blue.y = 119.5;
	hh_ch4_p01psdAssetSec3Notes1Blue.width = 78.50;
	hh_ch4_p01psdAssetSec3Notes1Blue.height = 147.00;
	hh_ch4_p01psdAssetSec3Notes1Blue.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec3Notes1Blue.onLayout) hh_ch4_p01psdAssetSec3Notes1Blue.onLayout();
	const hh_ch4_p01psdAssetSec3Notes3copy = this.hh_ch4_p01psdAssetSec3Notes3copy;
	ch4_p01_hh_ch4_p01psdAssetSec3Notes3copy.call(this.hh_ch4_p01psdAssetSec3Notes3copy);
	hh_ch4_p01psdAssetSec3Notes3copy.x = 1117.5;
	hh_ch4_p01psdAssetSec3Notes3copy.y = 134.5;
	hh_ch4_p01psdAssetSec3Notes3copy.width = 35.00;
	hh_ch4_p01psdAssetSec3Notes3copy.height = 117.00;
	hh_ch4_p01psdAssetSec3Notes3copy.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec3Notes3copy.onLayout) hh_ch4_p01psdAssetSec3Notes3copy.onLayout();
	const hh_ch4_p01psdAssetSec3Notes5Yellow = this.hh_ch4_p01psdAssetSec3Notes5Yellow;
	ch4_p01_hh_ch4_p01psdAssetSec3Notes5Yellow.call(this.hh_ch4_p01psdAssetSec3Notes5Yellow);
	hh_ch4_p01psdAssetSec3Notes5Yellow.x = 1265.25;
	hh_ch4_p01psdAssetSec3Notes5Yellow.y = 164.25;
	hh_ch4_p01psdAssetSec3Notes5Yellow.width = 109.50;
	hh_ch4_p01psdAssetSec3Notes5Yellow.height = 123.50;
	hh_ch4_p01psdAssetSec3Notes5Yellow.alpha = 1.00;
	if (hh_ch4_p01psdAssetSec3Notes5Yellow.onLayout) hh_ch4_p01psdAssetSec3Notes5Yellow.onLayout();
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetLayer0(this: Ich4_p01_hh_ch4_p01psdAssetLayer0) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer0", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetegmusbtnvar1(this: Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar1) {
	if (this.setLayoutTexture) this.setLayoutTexture("egmusbtnvar1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetegmusbtnvar2(this: Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar2) {
	if (this.setLayoutTexture) this.setLayoutTexture("egmusbtnvar2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetegmusbtnvar3(this: Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar3) {
	if (this.setLayoutTexture) this.setLayoutTexture("egmusbtnvar3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSection1(this: Ich4_p01_hh_ch4_p01psdAssetSection1) {
	if (this.setLayoutTexture) this.setLayoutTexture("Section1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSection2(this: Ich4_p01_hh_ch4_p01psdAssetSection2) {
	if (this.setLayoutTexture) this.setLayoutTexture("Section2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSection3(this: Ich4_p01_hh_ch4_p01psdAssetSection3) {
	if (this.setLayoutTexture) this.setLayoutTexture("Section3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec1Notes1Yellow(this: Ich4_p01_hh_ch4_p01psdAssetSec1Notes1Yellow) {
	if (this.setLayoutTexture) this.setLayoutTexture("1Yellow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec1Notes2(this: Ich4_p01_hh_ch4_p01psdAssetSec1Notes2) {
	if (this.setLayoutTexture) this.setLayoutTexture("2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec1Notes3(this: Ich4_p01_hh_ch4_p01psdAssetSec1Notes3) {
	if (this.setLayoutTexture) this.setLayoutTexture("3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec1Notes5Red(this: Ich4_p01_hh_ch4_p01psdAssetSec1Notes5Red) {
	if (this.setLayoutTexture) this.setLayoutTexture("5Red", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec2Notes5blue(this: Ich4_p01_hh_ch4_p01psdAssetSec2Notes5blue) {
	if (this.setLayoutTexture) this.setLayoutTexture("5blue", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec2Notes4Yellow(this: Ich4_p01_hh_ch4_p01psdAssetSec2Notes4Yellow) {
	if (this.setLayoutTexture) this.setLayoutTexture("4Yellow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec3Notes2Red(this: Ich4_p01_hh_ch4_p01psdAssetSec3Notes2Red) {
	if (this.setLayoutTexture) this.setLayoutTexture("2Red", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec3Notes1Blue(this: Ich4_p01_hh_ch4_p01psdAssetSec3Notes1Blue) {
	if (this.setLayoutTexture) this.setLayoutTexture("1Blue", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec3Notes3copy(this: Ich4_p01_hh_ch4_p01psdAssetSec3Notes3copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("3copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p01_hh_ch4_p01psdAssetSec3Notes5Yellow(this: Ich4_p01_hh_ch4_p01psdAssetSec3Notes5Yellow) {
	if (this.setLayoutTexture) this.setLayoutTexture("5Yellow", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich4_p01Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p01Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p01Sprite extends Ich4_p01Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p01Text extends Ich4_p01Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p01Polygon extends Array<number> {
}
interface Ich4_p01 {
	readonly buttons: Ich4_p01Array<Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar1|Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar2|Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar3>;
	readonly sections: Ich4_p01Array<Ich4_p01_hh_ch4_p01psdAssetSection1|Ich4_p01_hh_ch4_p01psdAssetSection2|Ich4_p01_hh_ch4_p01psdAssetSection3>;
	readonly bg: Ich4_p01_hh_ch4_p01psdAssetLayer0;
	readonly hh_ch4_p01psdAssetSec1Notes1Yellow: Ich4_p01_hh_ch4_p01psdAssetSec1Notes1Yellow;
	readonly hh_ch4_p01psdAssetSec1Notes2: Ich4_p01_hh_ch4_p01psdAssetSec1Notes2;
	readonly hh_ch4_p01psdAssetSec1Notes3: Ich4_p01_hh_ch4_p01psdAssetSec1Notes3;
	readonly hh_ch4_p01psdAssetSec1Notes5Red: Ich4_p01_hh_ch4_p01psdAssetSec1Notes5Red;
	readonly hh_ch4_p01psdAssetSec2Notes5blue: Ich4_p01_hh_ch4_p01psdAssetSec2Notes5blue;
	readonly hh_ch4_p01psdAssetSec2Notes4Yellow: Ich4_p01_hh_ch4_p01psdAssetSec2Notes4Yellow;
	readonly hh_ch4_p01psdAssetSec3Notes2Red: Ich4_p01_hh_ch4_p01psdAssetSec3Notes2Red;
	readonly hh_ch4_p01psdAssetSec3Notes1Blue: Ich4_p01_hh_ch4_p01psdAssetSec3Notes1Blue;
	readonly hh_ch4_p01psdAssetSec3Notes3copy: Ich4_p01_hh_ch4_p01psdAssetSec3Notes3copy;
	readonly hh_ch4_p01psdAssetSec3Notes5Yellow: Ich4_p01_hh_ch4_p01psdAssetSec3Notes5Yellow;
}
interface Ich4_p01_hh_ch4_p01psdAssetLayer0 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar1 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar2 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetegmusbtnvar3 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSection1 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSection2 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSection3 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec1Notes1Yellow extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec1Notes2 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec1Notes3 extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec1Notes5Red extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec2Notes5blue extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec2Notes4Yellow extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec3Notes2Red extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec3Notes1Blue extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec3Notes3copy extends Ich4_p01Sprite {
}
interface Ich4_p01_hh_ch4_p01psdAssetSec3Notes5Yellow extends Ich4_p01Sprite {
}
